import $ from "jquery";
import "./jquery.fittext.js"

//========================================
// FIT TEXT PLUGIN
//========================================
$("#fit-text-1").fitText(); // Welcome to Fit-Tools



// WEBPACK FOOTER //
// ./src/jQueryPlugins/main.js